import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import background from '../assets/background.webp';

const WorksPge = () => {
  const { t } = useTranslation();
  const translatedData = t("complexes_data", { returnObjects: true });

  // Генерируем массив из 33 объектов с путями к картинкам в папке public
  // Файлы должны лежать в: public/assets/works/1.png, 2.png и т.д.
  const Complexes = Array.from({ length: 33 }, (_, i) => ({
    img: `/assets/works/${i + 1}.png` 
  }));

  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.05, rootMargin: "0px 0px -20px 0px" },
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      style={{ backgroundImage: `url(${background})` }}
      ref={sectionRef}
      className={`m-auto bg-slate-800 bg-fixed flex flex-col items-center py-[150px] transition-all duration-700 ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      }`}
    >
      <h1
        className={`font-['Cormorant_Garamond'] text-yellow-500 uppercase text-[20px] md:text-[40px] lg:text-[64px] tracking-[0.15em] transition-all duration-700 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-6"
        }`}
      >
        {t("works_title")}
      </h1>

      <div className="grid flex-wrap grid-cols-1 md:grid-cols-2 xl:grid-cols-3 justify-center gap-6 mt-10 max-sm:p-6">
        {Complexes.map((item, index) => {
          const fullProjectData = {
            ...item,
            name: translatedData[index]?.name,
            info: translatedData[index]?.info,
          };

          return (
            <Link
              key={index}
              to={`/work/${index}`}
              state={{ project: fullProjectData }}
              className={`group w-[500px] max-lg:w-[400px] bg-white max-sm:w-full rounded-2xl overflow-hidden shadow-2xl transition-all duration-700 ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
              }`}
              style={{ transitionDelay: isVisible ? `${Math.min(index * 35, 700)}ms` : "0ms" }}
            >
              <div className="h-[250px] max-sm:h-[220px] overflow-hidden">
                <img
                  src={item.img} // Теперь берет путь "/assets/works/1.png" и т.д.
                  alt={fullProjectData.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition duration-500"
                />
              </div>

              <div className="p-5 text-center">
                <h3 className="font-['Cormorant_Garamond'] uppercase">
                  {fullProjectData.name || t("loading_player")}
                </h3>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
};

export default WorksPge;